import React from "react";

import { HALO_CSS } from "./document-intake-styles";

/** Monta una vez los estilos de halos y del resumen (los usa el resumen y los campos). */
export const IntakeHaloStyles = () => <style>{HALO_CSS}</style>;

/**
 * Inventario rapido de lo que leyo la IA: que datos clave se capturaron y cuales faltan. Es
 * puramente de presentacion; quien lo monta calcula `items` ([{ label, filled }]) para que se
 * actualice en vivo mientras la persona completa el formulario.
 */
const IntakeSummary = ({ items, documents = [], warnings = [], aiAssisted = true }) => {
  const filled = items.filter((item) => item.filled).length;
  const missing = items.length - filled;

  return (
    <div className="di-summary mb-3" aria-live="polite">
      <IntakeHaloStyles />
      <div className="font-weight-bold mb-2">
        <i className="fa fa-magic text-primary mr-2" />
        {filled} de {items.length} datos clave listos
      </div>
      <div>
        {items.map((item) => (
          <span key={item.label} className={`di-chip ${item.filled ? "ok" : "missing"}`}>
            {item.filled ? "✓" : "!"} {item.label}
          </span>
        ))}
      </div>
      {documents.length > 0 && (
        <div className="mt-1">
          <span className="small font-weight-bold mr-2">Documentos:</span>
          {documents.map((document) => (
            <span key={document.label} className={`di-chip ${document.loaded ? "ok" : "missing"}`}>
              {document.loaded ? "✓" : "!"} {document.label}
            </span>
          ))}
        </div>
      )}
      {missing > 0 && (
        <div className="small text-muted">Complementa los campos marcados en naranja para continuar.</div>
      )}
      {aiAssisted && (
        <div className="small text-muted mt-1">
          El caso se creará con la etiqueta <b>Captura asistida por IA</b>.
        </div>
      )}
      {warnings.length > 0 && (
        <ul className="small text-warning mt-2 mb-0 pl-3">
          {warnings.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default IntakeSummary;
